import React, { useState } from "react";
import {
	Form,
	Label,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Col,
	FormGroup,
	Button,
	Row,
} from "reactstrap";

import useCurrentSaleStore from "stores/SaleStore";
import useCurrentDealStore from "stores/DealStore";
import useCurrentRecapStore from "stores/RecapStore";
import Select from "react-select";
import { getDocument } from "api/TecAssuredAPI";
import { displayPdf } from "api/FormsAPI";
import { useFromUser } from "stores/LocalStorageHelper";
import InputElement, {
	IntegerInputElement,
	CurrencyInputElement,
} from "features/forms/components/InputElement";
import { useForm, FormProvider } from "react-hook-form";
import { DealStatus } from "constants/Constants";
import shallow from "zustand/shallow";

const GAPForm = () => {
	const [loading, setLoading] = useState(false);
	const locationID = useFromUser("locationID");

	// Sale Store
	const { gap, gapTerm, editGapTerm, editGap } = useCurrentSaleStore(
		(state) => ({
			gap: state.gap,
			gapTerm: state.gapTerm,
			editGapTerm: state.editGapTerm,
			editGap: state.editGap,
		}),
		shallow
	);
	// Deal Store
	const {
		insGapName,
		insGapRecNum,
		type,
		editInsGapName,
		editInsGapRecNum,
		gapCompanies,
		tecAssuredGapDocId,
	} = useCurrentDealStore(
		(state) => ({
			insGapName: state.deal.insGapName,
			insGapRecNum: state.deal.insGapRecNum,
			type: state.deal.type,
			editInsGapName: state.editInsGapName,
			editInsGapRecNum: state.editInsGapRecNum,
			gapCompanies: state.gapCompanies,
			tecAssuredGapDocId: state.deal.tecAssuredGapDocId,
		}),
		shallow
	);
	const { gapInsCost, editGapInsCost } = useCurrentRecapStore((state) => ({
		gapInsCost: state.gapInsCost,
		editGapInsCost: state.editGapInsCost,
	}));

	const gapComList = gapCompanies.map((obj) => {
		return {
			label: obj.name,
			value: obj.ID,
			gapCo: obj,
		};
	});

	// Define form validation parameters
	const methods = useForm();

	const handleGetFinalDoc = async () => {
		setLoading(true);
		try {
			if (tecAssuredGapDocId) {
				const res = await getDocument({
					documentId: tecAssuredGapDocId,
					locationId: locationID,
				});
				displayPdf(res);
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<Card>
			<CardHeader>
				<CardTitle tag="h3">Gap Insurance</CardTitle>
			</CardHeader>
			<CardBody>
				<FormProvider {...methods}>
					<Form>
						<Col>
							<FormGroup>
								<Label>Company</Label>
								<Select
									isDisabled={type !== DealStatus.PENDING}
									value={{
										value: insGapRecNum,
										label: gapComList.filter((e) => e.value === insGapRecNum)[0]
											?.label,
									}}
									options={gapComList}
									onChange={(e) => {
										editInsGapRecNum(e.value);
									}}
								/>
							</FormGroup>
							<FormGroup>
								<InputElement
									{...methods}
									readOnly={type !== DealStatus.PENDING}
									value={insGapName}
									onChange={(e) => {
										editInsGapName(e.target.value);
									}}
									name="insGapName"
									label="Gap Name"
									type="text"
									wholeRow={true}
								/>
							</FormGroup>
							<FormGroup>
								<IntegerInputElement
									readOnly={type !== DealStatus.PENDING}
									value={gapTerm}
									onChange={editGapTerm}
									name="gapTerm"
									label="Term in Months"
									type="number"
									wholeRow={true}
								/>
							</FormGroup>
							<FormGroup>
								<CurrencyInputElement
									readOnly={type !== DealStatus.PENDING}
									value={gapInsCost}
									onChange={editGapInsCost}
									name="gapInsCost"
									label="Cost"
									type="number"
									wholeRow={true}
								/>
							</FormGroup>
							<FormGroup>
								<CurrencyInputElement
									readOnly={type !== DealStatus.PENDING}
									value={gap}
									onChange={editGap}
									name="c"
									label="Amount"
									type="number"
									wholeRow={true}
								/>
							</FormGroup>
						</Col>
					</Form>
				</FormProvider>
				{tecAssuredGapDocId && (
					<Row className="mt-3">
						<Col xs="12">
							<Button
								color="success"
								block
								onClick={handleGetFinalDoc}
								disabled={loading}
							>
								{loading ? "Loading..." : "Get Final Document"}
							</Button>
						</Col>
					</Row>
				)}
			</CardBody>
		</Card>
	);
};

export default GAPForm;
